import React from "react";
import "./EventHistoryCard.css";
import { Avatar, Rate, Space, Grid, Typography } from "antd";
import dayjs from "dayjs";
import { awardTypesIcons } from "../../Config/helpers/constants";
import { MdGroups } from "react-icons/md";
import { KEYS } from "../../Config/Keys";
import { BiUser } from "react-icons/bi";
import TimelineDot from "./TimelineDot";
import { useLocation, useNavigate } from "react-router-dom";
const { useBreakpoint } = Grid;

function EventHistoryCard({ index, data, historyFor = "organizer" }) {
  const returnEventName = { player: "eventName", organizer: "name", panel: "name" };
  const breakpoints = useBreakpoint();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentUser = pathname.includes("player") ? "player" : "organizer";
  const eid = data?._id || 123;
  const groupedAwards =
    data?.awards?.length > 0 ? Object.groupBy(data?.awards, ({ awardType }) => awardType) : [];

  // group awards by getting total awards and cash
  const awards = Object.keys(groupedAwards)?.map((key) => {
    if (key === "cash") {
      let cashSum = 0;
      groupedAwards[key]?.forEach((element) => {
        cashSum += Number(element?.awardValue) || 0;
      });

      return {
        awardType: key,
        awardValue: cashSum
      };
    } else {
      return {
        awardType: key,
        awardValue: groupedAwards[key]?.length
      };
    }
  });

  const now = new Date();

  const currentEvents = new Date(data.endDate) > now;
  const concluded = new Date(data.endDate) <= now && (!data.awards || data.awards.length === 0);
  const hasAwards = new Date(data.endDate) <= now && data.awards && data.awards.length > 0;

  return (
    <div
      className={`wrapper ${
        concluded
          ? "concluded-container"
          : currentEvents
          ? "current-event-container"
          : "concluded-award-container"
      }`}
      style={{ cursor: "pointer" }}
      onClick={() => {
        if (currentUser === "player") {
          navigate(`/view/event/${eid}/timeline`, { state: "event" });
        } else if (currentUser === "organizer") {
          navigate(`/${currentUser}/event/${eid}/timeline`, { state: "event" });
        }
      }}>
      <div className={`clock-container ${index % 2 == 0 ? "right" : "left"}`}>
        {currentEvents && (
          <img src="/images/icons/clock1.png" alt="Clock Icon" className="clock-icon" />
        )}
        {concluded && (
          <img src="/images/icons/conclude1.png" alt="Clock Icon" className="tick-icon" />
        )}
        {hasAwards && (
          <img src="/images/icons/trophy-star1.png" alt="Clock Icon" className="award-icon" />
        )}

        <div
          className={`curved-underline ${
            concluded
              ? "concluded-curved"
              : currentEvents
              ? "current-event-curved"
              : "concluded-award-curved"
          }`}></div>
      </div>
      <div className={`${index % 2 == 0 ? "date-right" : "date-left"}`}>
        <p className="date ">
          {dayjs(data?.startDate).isSame(dayjs(), "day")
            ? "Today"
            : dayjs(data?.startDate).format("DD MMM YYYY") || "- no date"}
        </p>
      </div>

      <div className={`${index % 2 == 0 ? "content-right" : "content-left"}`}>
        <h2>{data?.[returnEventName?.[historyFor] || ""]}</h2>
        {/* on small screens show event image below title */}
        {!breakpoints?.md && (
          <TimelineDot
            img={data?.file?.file ? KEYS.API + "/" + data?.file?.file : "/images/homesports.png"}
          />
        )}
        <Space direction="horizontal" align="center" className="mb-2">
          {/* panel image goes here */}
          <Avatar size={40} icon={<MdGroups />} src={KEYS.API + "/" + data?.panelFile} />
          <p className="subHeading" style={{ marginBottom: "0" }}>
            {" "}
            {data?.panel?.name || data?.panel}
          </p>
        </Space>
        <div>
          <Rate allowHalf value={data?.rating ? Number(data?.rating) : 0} disabled />
        </div>
      </div>

      <div className="flex-between align-center">
        <p className="bold mb-1">
          <span>{data?.numberOfParticipants || data?.numberOfTeams}</span> Participants
          <Space style={{ marginLeft: "10px" }}>
            <Avatar.Group maxCount={6} size="default">
              {Array.from({ length: data?.numberOfParticipants || data?.numberOfTeams }).map(
                (_, i) => (
                  <Avatar key={i} size="small" icon={<BiUser />} />
                )
              )}
            </Avatar.Group>
          </Space>
        </p>
      </div>

      <div className="flex-between mt-1 text-center">
        <div>
          <p className="bold">Sponsored</p>
          <Typography.Text type="secondary"> - </Typography.Text>
        </div>
        <div>
          <p className="bold">Awards</p>
          <Space direction="vertical" align="start">
            {awards?.length > 0
              ? awards?.map((award, index) => (
                  <React.Fragment key={index}>
                    <Typography.Text type="secondary">
                      {" "}
                      <img
                        style={{ width: "24px", height: "24px" }}
                        src={`/images/icons/${
                          awardTypesIcons.includes(award?.awardType)
                            ? `${award?.awardType}`
                            : "certificate"
                        }.svg`}
                      />{" "}
                      {award?.awardValue} {award?.awardType !== "cash" && award?.awardType}
                    </Typography.Text>
                  </React.Fragment>
                ))
              : "-"}
          </Space>
        </div>
      </div>
    </div>
  );
}

export default EventHistoryCard;
